import ComponentView from './ComponentView';

export default ComponentView.extend({
  events: {}
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/dom_components/view/ComponentTableView.js